import { Injectable } from '@angular/core';
import { DbTableDefinition } from 'src/app/_services/persistence/db-persistence/db-table-definition';

@Injectable({
  providedIn: 'root',
})
export class BranchFunctionGroupsDbTableDefinition extends DbTableDefinition {
  tableName = 'branchFunctionGroups';
  tableStructure = `(id BIGINT(20) PRIMARY KEY null,
     branchid BIGINT(20),
     functiongroupid BIGINT(20),
     databag LONGTEXT
    );`;

  constructor() {
    super();
    this.updateStatements.set(38, [
      `CREATE TABLE IF NOT EXISTS ${this.tableName}${this.tableStructure}`,
    ]);
  }
}
